<template>
  <div id="app" class="flex flex-row bg-gray-100" :style="loadingpage?'background-color: #fff;':''">

    <!-- Public pages (no auth required) -->
    <router-view v-if="isPublicRoute"></router-view>

    <!-- Login page for non-authenticated users -->
    <Login v-else-if="!login"> </Login>

    <side-bar v-if="login && !isPublicRoute && user && user.status == 'active' && $route.name!='createStore'" :user="user"></side-bar>
    <main v-if="login && !isPublicRoute" :class="!ShowSidebar() || resize()?'mll-0 show-menu':''" class="flex ml-5 flex-col flex-auto w-full min-w-0">
      <top-bar v-if="$route.name!='createStore'" :user="user" :idWharhouse="idWharhouse" :sous_idWharhouse="sous_idWharhouse" :sous_warehouses="sous_warehouses" class="sticky top-0"></top-bar>
       <vue-ins-progress-bar></vue-ins-progress-bar>
      <router-view :currentUser="user" :idWharhouse="idWharhouse" :sous_idWharhouse="sous_idWharhouse" :sous_warehouses="sous_warehouses"/>
     <div v-if="$route.name!='createStore'" class="relative  flex flex-0 items-center justify-start w-full h-14 px-4 md:px-6 z-49 border-t bg-card dark:bg-transparent"><span class="font-medium text-secondary">ML AFRICA © {{new Date().getFullYear()}}</span></div> 
     <!-- <vue-modal-2  name="ModalFormation" :headerOptions="{title: 'Formation videos'}" :noFooter="true" modalSize="xl" @on-close="closeModal()">
          <div class="bg-white rounded-lg mb-10">
            <h3 class="font-bold mb-4 pl-5">Vidéos tutoriels pour utiliser la plateforme mlexpress (<img data-v-37e6d7d6="" src="https://static.dwcdn.net/css/flag-icons/flags/4x3/fr.svg" alt="fr" class="h-4 w-5 inline-block">)</h3>
            <div class="grid lg:grid-cols-3 grid-cols-3 gap-6 videos">
                <iframe id="video" class="mt-3"  src="https://www.youtube.com/embed/aBFvrqwfrKM?si=5UqVvGGl8tmmjo4f" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                <iframe  class="mt-3"  src="https://www.youtube.com/embed/i5PVHk_fmBU?si=0GpqvGvhropaKeIk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                <iframe  class="mt-3"  src="https://www.youtube.com/embed/DIZyhb9HYBo?si=53rj8np-vqC7HJ42" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>
            <h3 class="font-bold my-4 pr-5" style="direction: rtl;">فيديوهات تعليمية لكيفية استعمال منصة mlexpress (<img data-v-37e6d7d6="" src="https://static.dwcdn.net/css/flag-icons/flags/4x3/ma.svg" alt="fr" class="h-4 w-5 inline-block">)</h3>
            <div style="direction: rtl;" class="grid lg:grid-cols-3 gap-6 videos" >
              <iframe class="mt-3" src="https://www.youtube.com/embed/3Oy-DTUQVuY?si=ZZPO01MM9ZbmUKto" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              <iframe class="mt-3" src="https://www.youtube.com/embed/hAbTh7y8LcA?si=gUw3Om1gmoCLACxJ" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
              <iframe class="mt-3" src="https://www.youtube.com/embed/vm9lUo-j0C8?si=33rFl0RmJG2OXkIe" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>

            <h3 class="font-bold my-4 pr-5" style="direction: rtl;">شرح طريقة UPsell</h3>
            <div style="direction: rtl;" class="grid lg:grid-cols-3 gap-6 videos" >
                <iframe class="mt-3" src="https://www.youtube.com/embed/fGNyZCfFNkQ?si=4AsCqE6ke8e9lubr" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>


            <h3 class="font-bold mb-4 pl-5">Intégration mlexpress && Google Sheet</h3>
            <div class="grid lg:grid-cols-3 gap-6 videos" >
                <iframe class="mt-3" src="https://www.youtube.com/embed/nWA--crrvuQ?si=0y7Nz5_bNTFhiR2j" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </div>

          </div>
      </vue-modal-2>   -->
      
    </main>

    <!-- Chat Widget for authenticated Sellers and Account Managers -->
    <ChatWidget v-if="login && canUseChat && !isPublicRoute && $route.name!='createStore'" />

    <div v-if="loadingpage" id="loadingpage">
      <div class="lp-box">
        <img class="lp-logo" src="https://storeno.b-cdn.net/rmexpressglob-v1/12-2024/1733757434470.jpeg" alt="RM Express" />
        <div class="loader loader-mixed">
            <svg xmlns="http://www.w3.org/2000/svg" xmlns:svgjs="http://svgjs.com/svgjs" xmlns:xlink="http://www.w3.org/1999/xlink" width="120" height="120"><svg xmlns="http://www.w3.org/2000/svg" class="lds-microsoft" preserveAspectRatio="xMidYMid" viewBox="0 0 100 100" style="background:0 0" width="120" height="120"><g class="color000 svgShape"><circle cx="73.801" cy="68.263" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(125.399 50 50)"><animateTransform attributeName="transform" begin="0s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="68.263" cy="73.801" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(153.871 50 50)"><animateTransform attributeName="transform" begin="-0.062s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="61.481" cy="77.716" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(182.969 50 50)"><animateTransform attributeName="transform" begin="-0.125s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="53.916" cy="79.743" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(213.399 50 50)"><animateTransform attributeName="transform" begin="-0.187s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="46.084" cy="79.743" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(241.838 50 50)"><animateTransform attributeName="transform" begin="-0.25s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="38.519" cy="77.716" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(267.328 50 50)"><animateTransform attributeName="transform" begin="-0.312s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="31.737" cy="73.801" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(289.993 50 50)"><animateTransform attributeName="transform" begin="-0.375s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><circle cx="26.199" cy="68.263" r="3" fill="#4ec16f" class="color564ec1 svgShape" transform="rotate(308.811 50 50)"><animateTransform attributeName="transform" begin="-0.437s" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;360 50 50"/></circle><animateTransform attributeName="transform" calcMode="spline" dur="1.5s" keySplines="0.5 0 0.5 1" repeatCount="indefinite" type="rotate" values="0 50 50;0 50 50"/></g></svg></svg>
        </div>
        <div class="loading-info">Chargement des données<span class="lp-dots"><i>.</i><i>.</i><i>.</i></span></div>
      </div>
    </div>
    <vue-modal-2  name="RefreshPage" :headerOptions="{title: `Nouvelle mise à jour`}" :noFooter="true" modalSize="md">
          <div class="bg-white rounded-lg">
              <div class="rounded-lg">
                <p class="p-4 pt-0 font-bold"><svg class="fill-current mr-1 inline-block" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m11.998 2.001c5.517 0 9.997 4.48 9.997 9.997 0 5.518-4.48 9.998-9.997 9.998-5.518 0-9.998-4.48-9.998-9.998 0-5.517 4.48-9.997 9.998-9.997zm-4.496 6.028-.002-.825c0-.414-.336-.75-.75-.75s-.75.336-.75.75v3.048c0 .414.336.75.75.75h3.022c.414 0 .75-.336.75-.75s-.336-.756-.75-.756h-1.512c.808-1.205 2.182-1.998 3.74-1.998 2.483 0 4.5 2.016 4.5 4.5 0 2.483-2.017 4.5-4.5 4.5-1.956 0-3.623-1.251-4.242-2.997-.106-.299-.389-.499-.707-.499-.518 0-.88.513-.707 1.001.825 2.327 3.048 3.995 5.656 3.995 3.312 0 6-2.689 6-6 0-3.312-2.688-6-6-6-1.79 0-3.399.786-4.498 2.031z" fill-rule="nonzero"/></svg> 
                  Une nouvelle mise à jour améliorée de l'application est maintenant disponible, actualiser la page SVP. 
                </p>
              </div>
              <div class="p-4 w-full text-right">
                  <button  @click="RefreshPage()" class="w-1/2 px-4 py-3 text-center text-blue-100 bg-green-600 rounded-lg hover:bg-green-700 hover:text-white font-bold text-sm loidingconfirm relative"><i style="vertical-align: middle;" class="material-icons text-white mr-1">refresh</i> Actualiser maintenant</button>
              </div>
          </div>
      </vue-modal-2>   
    


  </div>
</template>
<script>
//import button from './components/~/button.vue';
import ChatWidget from './components/Chat/ChatWidget.vue';
import { socketService } from '@/plugins/socket';

export default {
  components: { ChatWidget },
  data() {
    return {
      login: false,
      loading:false,
      loadingpage:false,
      fullPage:false,
      user: {},
      typeUser:"",
      idWharhouse:null,
      sous_idWharhouse:null,
      sous_warehouses:[],
    };
  },
  created() {
    //console.log('document.readyState -----',document.readyState )
    if(document.readyState == 'loading')  {this.loadingpage=true}
    let vm = this;
    document.addEventListener('readystatechange',function (ev) {
     // console.log("statechange", document.readyState);
      if (document.readyState == "complete") { 
        console.log("statechange vv", document.readyState);
          setTimeout(function () { vm.loadingpage=false; } , 800)
          console.log("statechange vv",  vm.loadingpage);
        } 
    })
    
  },
  computed: {
    itemsSousWarehousesLength() {
       return this.$store.state.sous_warehouses.length;
    },
    isPublicRoute() {
       return this.$route.meta && this.$route.meta.public === true;
    },
    canUseChat() {
       // Only Sellers and Account Managers can use the chat widget
       return this.user && ['Seller', 'AccountManager'].includes(this.user.type);
    }
  }, 
  watch: {
    '$store.state.loading': async function(oldVal, newVal) {
        //  console.log('new loading-----',oldVal)
            this.loadingpage=oldVal
    },
    '$store.state.update': async function(oldVal, newVal) {
        //console.log('new update data mise ajour-----',oldVal);
        //console.log('new update pr_version mise ajour-----',this.$store.state.pr_version);
       // if(oldVal) this.openClosePopup('open');
        //this.loadingpage=oldVal
    },
    "$store.state.wharhouse.warhouseSelected": {
      async handler(newValue, oldValue) {
          //   console.log('oldValue--------',newValue)
             await this.getwharhouseId(newValue.code||newValue);
           //  console.log('country--------',newValue)
             //console.log('id ware--------',this.idWharhouse)
            },
            deep: true
    },
    "$store.state.wharhouse.sous_warhouseSelected": {
           async handler(newValue, oldValue) {
               // console.log('oldValue sous_warhouseSelected--------',newValue)
                this.sous_idWharhouse=newValue;
            },
            deep: true
      },
      itemsSousWarehousesLength (val, oldVal) {
         // console.log('lenght sous_warehouses changed!',this.$store.state.sous_warehouses);
          if(this.$store.state.sous_warehouses){
            this.sous_warehouses=this.$store.state.sous_warehouses;
            //console.log('sous_warehouses changed!',this.sous_warehouses);
          }
      }
  },
  async mounted() {
    console.log('app 11 -----',this.$store.state.wharhouse.warhouseSelected)
   await this.getAccess();
   //await this.getwharhouseId(this.$store.state.wharhouse.warhouseSelected);
   document.onreadystatechange = (event) => { 
   // console.log('document.readyState onreadystatechange -----',event)
        if(document.readyState == "complete") { 
          this.loadingpage=false;
        } 
      }
  },
  methods: {
    closeModal(){
        this.$vm2.close('ModalFormation');
        $("iframe").each(function() { 
            var src= $(this).attr('src');
            $(this).attr('src',src);  
       });
    },
    pauseVideo(){
      var iframe = document.getElementById('video');
      // $f == Froogaloop
      var player = $f(iframe);

      var pauseButton = document.getElementById("click-to-close");
    // it is now hidden, we can't access it anymore...
        player.api("pause");
    },
    async getwharhouseId(country){
        const resW = await this.$server.get("warehouses", {country:country}); 
        if(resW && resW.content) this.idWharhouse=resW.content;
        //console.log('satatu get-------------- app',this.idWharhouse)
    },
     RefreshPage(){
      console.log('new update pr_version mise ajour-----',this.$store.state.pr_version);
       if(this.user && this.user._id) {
          localStorage.setItem('pr-version',this.$store.state.pr_version);
          window.location.reload();
        }
    },
     openClosePopup(type){
      console.log('type-------',type)
       if(type=='open') this.$vm2.open('RefreshPage');
       else this.$vm2.close('RefreshPage');
    },
     ShowSidebar(){
       return  this.$store.getters.ShowSidebar;
    },
    resize(){
       return  this.$store.getters.resize;
    },
    async getAccess() {
      this.loading=true;
      const tokenExist = this.$jwtService.verifyToken();
      if (tokenExist) {
        const token = this.$jwtService.getToken();
        const dataUser = await this.$me;
        if (dataUser && dataUser.status &&  dataUser.status == 200) {
          this.typeUser=dataUser.content.type;
          this.user=dataUser.content;
           const resW = await this.$server.get("warehouses", {country:this.$store.state.wharhouse.warhouseSelected}); 
           if(resW && resW.content) this.idWharhouse=resW.content;
           if(['Seller','StockManager','Administrateur'].indexOf(this.user.type) == -1){ 
              const resW = await this.$server.search("warehouses", { country: this.idWharhouse.country,all:true,limit:10}); 
              if(resW.content && resW.content.results) {
                this.user.sous_warehouses=resW.content.results.filter(item => !item.is_primary).sort((a,b) => (a._id > b._id) ? 1 : ((b._id > a._id) ? -1 : 0));
                this.sous_warehouses=this.user.sous_warehouses.map(warehouse => ({ _id: warehouse._id, name: warehouse.name }));
                if(this.sous_warehouses && this.sous_warehouses.length>0) this.sous_warehouses.splice(0, 0, {_id:'all',name:'all'});
                this.$store.dispatch("actionSousWarehouses",{sous_warehouses:this.sous_warehouses}); 
              }
           }else {this.user.sous_warehouses=this.sous_warehouses=[];}
           this.sous_idWharhouse=await this.$store.getters["wharhouse/sous_warhouseSelected"]({user:_.pick(this.user,['sous_warehouses','type'])})||null;
          if(['Seller','sourcing'].includes(this.user.type)) this.$store.dispatch("actionupdate",{update:false,NewNotifs:this.user.notifications?this.user.notifications.filter(el => !el.vue).length:0,OldNotifs:this.user.notifications?this.user.notifications.filter(el => !el.vue).length:0});

          if (this.$f.getAccess(this.user.role.permissions,'settings','read')){
              const {content:dataSetting} = await this.$server.get("settings");
              this.$store.dispatch("actionSeller", { user: this.user,settings:dataSetting.details,settingsGlobal:dataSetting });
          }

           this.$store.dispatch("actionSeller",{user:this.user});
           this.login = true;

           this.setupYoucanSocketListeners();
        }
      }
      this.loading=false;
    },
    setupYoucanSocketListeners() {
      if (!this.user || !['Seller', 'Partner'].includes(this.user.type)) return;
      if (this.user.accountType && !this.user.accountType.includes('seller')) return;

      try {
        socketService.connect(this.$store);

        socketService.on('youcan_connected', (data) => {
          const msg = `YouCan store "${(data && data.storeName) || 'connected'}" — orders will sync automatically.`;
          if (this.$toast && this.$toast.success) this.$toast.success(msg);
          else if (window.alert) window.alert(msg, 'success', 4);
        });

        socketService.on('youcan_order_imported', (data) => {
          const who = (data && data.customerName) || 'A customer';
          const price = (data && data.totalPrice) ? ` (${data.totalPrice})` : '';
          const msg = `New YouCan order from ${who}${price}`;
          if (this.$toast && this.$toast.info) this.$toast.info(msg);
          else if (window.alert) window.alert(msg, 'default', 4);
        });
      } catch (e) {
        console.error('YouCan socket setup failed:', e);
      }
    },
  },
};
</script>
<style>
.pleaseWait-text, .manualDownload-text {
  font-size: 1.1rem;
  font-weight: 600;
}
.pb-30{
  padding-bottom: 30px;
}
.loader {
    display: flex;
    justify-content: center;
    align-items: center;
}

.loader span {
    font-size: 40px;
    animation: spin 2s linear infinite;
}
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}
.api-imgae .expandable-image img {
  width: 60% ;
  height: auto ;
  border-radius: 0% ;
}
.w10{
  width: 10% !important;
 }
 .w40{
  width: 40% !important;
 }
 .summary .square {
    height: 80px;
    border-radius: 5px;
    background: rgba(130, 130, 130, 0.2);
    background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
    background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
    background-size: 800px 100px;
    animation: wave-squares 2s infinite ease-out;
}
.summary .line {
    width: 40%;
    height: 17px;
    border-radius: 2px;
    background: rgba(130, 130, 130, 0.2);
    background: -webkit-gradient(linear, left top, right top, color-stop(8%, rgba(130, 130, 130, 0.2)), color-stop(18%, rgba(130, 130, 130, 0.3)), color-stop(33%, rgba(130, 130, 130, 0.2)));
    background: linear-gradient(to right, rgba(130, 130, 130, 0.2) 8%, rgba(130, 130, 130, 0.3) 18%, rgba(130, 130, 130, 0.2) 33%);
    background-size: 800px 100px;
    animation: wave-lines 2s infinite ease-out;
}
.balances .summary {
    position: relative;
    cursor: pointer;
    padding: 1em 0.5em;
    list-style: none;
}
.balances .summary div {
    display: flex;
    align-items: center;
}
.balances .summary span:first-child {
    width: 4rem;
    height: 4rem;
    border-radius: 10px;
    background-color: #f3e1e1;
    display: flex;
    flex-shrink: 0;
    align-items: center;
    justify-content: center;
    margin-right: 1.25em;
}
.balances .summary span:first-child svg {
    width: 2.25rem;
    height: 2.25rem;
}
.balances .summary h3 {
    display: flex;
    flex-direction: column;
}
.balances .summarystrong {
    font-weight: 700;
}
.balances .summary small {
    color: #999;
    font-size: 0.875em;
}
.balances .summary span:last-child {
    font-weight: 700;
    margin-left: auto;
}
@keyframes wave-lines {
    0% {
        background-position: -468px 0;
    }
     100% {
        background-position: 468px 0;
    }
}
@keyframes wave-squares {
    0% {
        background-position: -468px 0;
    }
     100% {
        background-position: 468px 0;
    }
}
.trans-list {
  display: block;
  padding: 0 15px;
}
.sellerbalance{
   margin-bottom: 70px;
}
.trans:last-child{
  border-bottom: none;
}
.trans {
  border-bottom: 1px solid #828181;
  padding-top: 15px;
}
.trans:first-child .trans-details,.trans:first-child .trans-amt{
  margin-top: 0;
}
.trans-details {
  display: inline-block;
  width: 75%;
}

.trans-details .status{
  display: inline-block;
  margin-left: 2px;
}
.trans-details .status span{
  border-radius: 4px;
  padding: 0 4px 3px 4px;
}

.trans-details .pending span{
  background-color: #ea9f0f;
  color: black;
}

.trans-details .rejected span{
  background-color: #ec2929;
  color: white;
}

.trans-minus {
  width: 30px;
  height: 30px;
  display: block;
  float: left;
  position: relative;
  top: 15px;
  
}
.marketplace tr {
  background: linear-gradient(90deg, #049cc7, #0a7ad426);
}

.marketplace tr:hover {
  background: linear-gradient(90deg, #087d9e, #0a7ad426);
}

.trans-plus {
  background-image: url(https://img.icons8.com/fluency/48/plus.png);
  background-repeat: no-repeat;
  width: 40px;
  height: 50px;
  display: block;
  float: left;
  position: relative;
  top: 15px;
}
.trans-name {
  display: inline-block;
}
.trans-name, .trans-type-date {
  margin: 3px;
}
.trans-type-date {
  color: #888;
  padding-left: 30px;
  margin-top: -5px !important;
  font-size: 12px;
  padding-bottom: 10px;
}
.proof .trans-type-date {
  padding-left: 70px;
  margin-top: -13px !important;
}
.trans-type-date i{
  font-size: 12px;
  line-height: 1;
  vertical-align: -.125em;
}
.trans-type-actions{
  padding-left: 30px;
  margin-top: -10px;
}
.trans-amount{
  width: 24%;
}
.trans-amount .btn-confirm{
  height: 25px;
  width: 100%;
  margin-top: 5px;
  align-items: center;
  justify-content: center;
  font-size: 14px;
}
.trans-name, .trans-type-date {
  margin: 3px;
}
.amt-red {
  color: rgb(186, 18, 41);
}
.amt-green {
  color: rgb(113, 207, 66);
}
.trans-amt {
  float: right;
  line-height: 55px;
  font-size: 18px;
  font-weight: 500;
}
.action-sheet-content .total {
  align-self: start;
  justify-self: center;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.action-sheet-content .total .label {
  text-transform: uppercase;
  font-weight: 100;
  font-size: 0.8rem;
  color: #828393;
}
.action-sheet-content .total .value {
  font-size: 1.8rem;
}
.action-sheet-content {
    padding: 20px 16px;
    max-height: 460px;
    overflow: auto;
    margin-bottom: 50px;
    padding-top: 0;
}
.action-sheet-content .form-group.basic {
    padding: 8px 0;
    margin: 0;
}
.action-sheet-content .form-group {
    width: 100%;
}
.action-sheet-content .form-group .input-wrapper {
    position: relative;
}
.action-sheet-content .form-group .label {
    font-size: 11px;
    margin: 0;
    font-weight: 500;
    color: #27173E;
    display: block;
    line-height: 1.2em;
    text-align: left;
}


.action-sheet-content .input-group {
    position: relative;
    display: flex;
    flex-wrap: wrap;
    align-items: stretch;
    width: 100%;
}
.action-sheet-content .input-group:not(.has-validation)>:not(:last-child):not(.dropdown-toggle):not(.dropdown-menu) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
}
.action-sheet-content .input-group .input-group-text {
    background: transparent;
    border: 0;
    border-bottom: 1px solid #DCDCE9;
    border-radius: 0;
    font-weight: 400;
    color: #27173E;
    height: 40px;
    width: auto;
    padding: 0 10px 0 0;
    display: flex;
    align-items: center;
    font-size: 1rem;
    line-height: 1.5;
    text-align: center;
    white-space: nowrap;
}
.action-sheet-content .input-group>:not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
    margin-left: -1px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
}
.action-sheet-content .form-group.basic .form-control, .action-sheet-content .form-group.basic .custom-select{
    background: transparent;
    border: none;
    border-bottom: 1px solid #DCDCE9;
    padding: 0;
    border-radius: 3px;
    height: 40px;
    color: #27173E;
    font-size: 15px;
    display: block;
    width: 100%;
    font-weight: 400;
    line-height: 1.5;
}
.trans-amount .form-control {
     background: transparent;
    border: 1px solid #27173E;
    padding: 0;
    border-radius: 3px;
    height: 35px;
    color: #27173E;
    font-size: 15px;
    display: block;
    width: 100%;
    font-weight: 400;
    line-height: 1.5;
}
.action-sheet-content .form-group.basic .form-control:focus,.trans-amount .form-control:focus {
    border-bottom-color: #6236FF;
    box-shadow: inset 0 -1px 0 0 #6236FF;
}

.action-sheet-content .form-control:focus,.trans-amount .form-control:focus  {
    border-color: none;
    outline: 0;
}
.trans-list .action-sheet-content{
  max-height: inherit;
  margin-bottom: 0;
  padding-top: 0;
}
.trans-list .action-sheet-content .total{
  padding-top: 0;
  padding-bottom: 0;
}

.action-sheet-content  .input-group>.form-control,.action-sheet-content  .input-group>.form-select {
    position: relative;
    flex: 1 1 auto;
    width: 1% !important;
    min-width: 0;
}
.add-card-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.add-card-info p {
  font-size: 16px;
  margin-bottom: 10px;
  color: #707070;
}
.add-card-info h3 {
  font-size: 24px;
  margin-bottom: 0;
  font-weight: 500;
}
.add-balance {
  text-align: center;
}
.balance-hold{
  padding: 1px 5px;
  padding-right:0;
  border-radius: 2px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.balance-hold.hold-red{
  background: #ec474738;
  color: #7b0b0b;
}
.balance-hold.hold-green{
  background: #31a00938;
  color: #30991b;
}
.balance-hold .hold{
  border: 1px solid red;
  font-weight: bold;
  padding: 0px 3px;
  border-radius: 2px;
  font-size: 8px;
  margin-left: auto;
  color: red;
}
.balance-hold .value{
  padding-right: 5px;
}
.balance-hold .etoil{
  vertical-align: sub;
}
.add-balance p {
  font-size: 14px;
  margin-bottom: 0;
  color: #111111;
}
.add-balance button {
  border-radius: 3px;
  background-color: rgba(54, 70, 205, 0.1);
  font-size: 15px;
  color: #3646cd;
  padding: 9px 12px;
  display: inline-block;
}
.balances .add-card {
  padding: 10px 15px;
  background-color: #fff;
  box-shadow: 0 2px 0 0 #01a653;
  border-radius: 8px;
  min-height: 115px;
}
/* .section-to-header {
  margin-top: -10px;
} */
 .balance-in{
  color: green;
 }
 .balance-out{
  color: red;
 }
.add-project-link .categories {
  background-repeat: no-repeat;
  background-size: cover;
  width: 100px;
  height: 100%;
  position: absolute;
  right:8px;
  background-position: center;
  /* padding: 6px 0; */
}
.add-project-link .categories-content .text {
  font-size: 16px;
  font-weight: 700;
  color: #051A1A;
}
.add-project-link .categories-content img {
  margin-top: -12px;
  height: 26px;
  display: inline-block;
}
.add-project-link .categories-content {
  padding: 22px 15px;
}
.add-project-link  .f-12 {
  font-size: 12px !important;
}
.add-project-link  .d-block {
  display: block !important;
}
.add-project-link  .text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.col-8 {
  flex: 0 0 auto;
  width: 66.66666667%;
}
.add-project-link {
  background-color: rgb(1 166 84 / 18%);
  min-height: 5%;
  margin-bottom: 15px;
  border: 1px solid #E6E9EB !important;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  letter-spacing: 0.5px;
  border-radius: 8px;
  -webkit-box-shadow: 0px 9px 20px rgba(46, 35, 94, 0.07);
  box-shadow: 0px 9px 20px rgba(46, 35, 94, 0.07);
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  color: #202429;
  word-wrap: break-word;
  background-clip: border-box;
}
.add-project-link.affiliatesAnalytics{
  min-height: 5%;
}
.affiliatesAnalytics .items-balances:after{
  height: 21px;
  top: -13px;
}
.refunds .header-1 .content{
  width: 50%;
  height: auto;
}

body:has(.ordersanalytics, .ordersstocks) .analytics,body:has(.tickets, .contactchat, .contactemail) .supports,body:has(.credits,.charges,.payments,.balancesrequests,.wallets) .paymentss,body:has(.affiliatesanalytics) .affiliates,body:has(.affiliatesrequests) .affiliates,body:has(.affiliatesoffers) .affiliates,body:has(.salariespointage) .salaires,body:has(.salaries) .salaires,body:has(.salariesavances) .salaires,body:has(.salariessettings) .salaires,body:has(.printerdesigns) .pod,body:has(.printermockups) .pod, body:has(.printermockupcreate)  .pod ,
body:has(.marketplacesdemands) .marketplaces,body:has(.marketplacesproducts) .marketplaces,body:has(.marketplacesrequests) .marketplaces
{
  display: block;
}
.rtl-direction {
  direction: rtl;
}
/* Buttons Style */
.btn {
    line-height: 1.5rem;
    padding: 10px 1rem;
    border-radius: 0.25rem;
    text-transform: capitalize;
    transition-property: all;
    transition-duration: 150ms;
    position: relative;
    white-space: normal;
}

@media (min-width: 768px) {
    .btn {
        padding: 0.75rem 1.5rem;
        white-space: nowrap;
    }
}

.btn.btn-sm {
    font-size: 0.813rem;
    padding: 0.5rem 0.75rem;
}

@media (min-width: 768px) {
    .btn.btn-sm {
        padding: 0.5rem 1rem;
    }
}

.btn.btn-md {
    font-size: 0.875rem;
    padding: 0.5rem 1rem;
}

@media (min-width: 768px) {
    .btn.btn-md {
        padding: 0.625rem 1.25rem;
        white-space: nowrap;
    }
}

.btn.btn-lg {
    font-size: 1rem;
    padding: 0.5rem 1rem;
}

@media (min-width: 768px) {
    .btn.btn-lg {
        padding: 0.5rem 1.25rem;
        white-space: nowrap;
    }
}

.btn.btn-xl {
    font-size: 1rem;
    padding: 0.75rem 1.25rem;
}

@media (min-width: 768px) {
    .btn.btn-xl {
        padding: 0.75rem 1.25rem;
    }
}

.btn.block-btn {
    display: block;
    width: 100%;
    text-align: center;
}

.btn.block-btn span {
    justify-content: center;
}

.btn-dark {
    background-color: rgb(15, 23, 42);
    color: white;
}

.btn-dark:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(0, 0, 0, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

.btn-primary {
    background-color: rgb(25, 166, 157);
    color: white;
}

.btn-primary:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(25, 166, 157, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

.btn-secondary {
    background-color: rgb(166, 174, 191);
    color: white;
}

.btn-secondary:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(166, 174, 191, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

.btn-success {
    background-color: rgb(34, 197, 94);
    color: white;
}

.btn-success:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(34, 197, 94, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

.btn-info {
    background-color: #0ce7fa;
    color: white;
}

.btn-info:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(12, 231, 250, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

.btn-warning {
    background-color: rgb(235, 91, 0);
    color: white;
}

.btn-warning:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(235, 91, 0, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

.btn-danger {
    background-color: rgb(239, 68, 68);
    color: white;
}

.btn-danger:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(239, 68, 68, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

.btn-light {
    background-color: rgb(241, 245, 249);
    color: rgb(15, 23, 42);
}

.btn-light:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(224, 234, 255, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

.btn-blue {
    background-color: rgb(59, 130, 246);
    color: white;
}

.btn-blue:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(59, 130, 246, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

.btn-purple {
    background-color: #693382;
    color: white;
}

.btn-purple:hover {
    --tw-ring-offset-width: 1px;
    --tw-ring-opacity: 0.8;
    --tw-ring-color: rgba(105, 51, 130, var(--tw-ring-opacity));
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow),
        var(--tw-shadow, 0 0 #0000);
}

/* Button outlines */
.btn-outline-dark {
    background-color: transparent;
    color: rgb(15, 23, 42);
    border-width: 1px;
    border-color: rgb(0, 0, 0);
}

.btn-outline-dark:hover {
    border-color: rgb(0, 0, 0);
    background-color: rgba(15, 23, 42, 0.05);
}

.btn-outline-dark.active {
    background-color: rgb(15, 23, 42);
    color: white;
}

[aria-expanded="true"]>.btn-outline-dark {
    background-color: rgb(15, 23, 42);
    color: white;
}

.btn-outline-primary {
    background-color: transparent;
    color: rgb(25, 166, 157);
    border-width: 1px;
    border-color: rgb(25, 166, 157);
}

.btn-outline-primary:hover {
    border-color: rgb(25, 166, 157);
    background-color: rgba(25, 166, 157, 0.05);
}

.btn-outline-primary.active {
    background-color: rgb(25, 166, 157);
    color: white;
}

[aria-expanded="true"]>.btn-outline-primary {
    background-color: rgb(25, 166, 157);
    color: white;
}


.btn-outline-secondary {
    background-color: transparent;
    color: rgb(160, 174, 192);
    border-width: 1px;
    border-color: rgb(160, 174, 192);
}

.btn-outline-secondary:hover {
    border-color: rgb(160, 174, 192);
    background-color: rgba(160, 174, 192, 0.05);
}

.btn-outline-secondary.active {
    background-color: rgb(160, 174, 192);
    color: white;
}

[aria-expanded="true"]>.btn-outline-secondary {
    background-color: rgb(160, 174, 192);
    color: white;
}


.btn-outline-blue {
    background-color: transparent;
    color: rgb(59, 130, 246);
    border-width: 1px;
    border-color: rgb(59, 130, 246);
}

.btn-outline-blue:hover {
    border-color: rgb(59, 130, 246);
    background-color: rgba(59, 130, 246, 0.05);
}

.btn-outline-blue.active {
    background-color: rgb(59, 130, 246);
    color: white;
}

[aria-expanded="true"]>.btn-outline-blue {
    background-color: rgb(59, 130, 246);
    color: white;
}

.btn-outline-success {
    background-color: transparent;
    color: rgb(34, 197, 94);
    border-width: 1px;
    border-color: rgb(34, 197, 94);
}

.btn-outline-success:hover {
    border-color: rgb(34, 197, 94);
    background-color: rgba(34, 197, 94, 0.05);
}

.btn-outline-success.active {
    background-color: rgb(34, 197, 94);
    color: white;
}

[aria-expanded="true"]>.btn-outline-success {
    background-color: rgb(34, 197, 94);
    color: white;
}

.btn-outline-info {
    background-color: transparent;
    color: #0ce7fa;
    border-width: 1px;
    border-color: #0ce7fa;
}

.btn-outline-info:hover {
    border-color: #0ce7fa;
    background-color: rgba(12, 231, 250, 0.05);
}

.btn-outline-info.active {
    background-color: #0ce7fa;
    color: white;
}

[aria-expanded="true"]>.btn-outline-info {
    background-color: rgb(56, 189, 248);
    color: white;
}

.btn-outline-warning {
    background-color: transparent;
    color: #fa916b;
    border-width: 1px;
    border-color: #fa916b;
}

.btn-outline-warning:hover {
    border-color: #fa916b;
    background-color: rgba(250, 145, 107, 0.05);
}

.btn-outline-warning.active {
    background-color: #fa916b;
    color: white;
}

[aria-expanded="true"]>.btn-outline-warning {
    background-color: rgb(245, 158, 11);
    color: white;
}

.btn-outline-danger {
    background-color: transparent;
    color: rgb(239, 68, 68);
    border-width: 1px;
    border-color: rgb(239, 68, 68);
}

.btn-outline-danger:hover {
    border-color: rgb(239, 68, 68);
    background-color: rgba(239, 68, 68, 0.05);
}

.btn-outline-danger.active {
    background-color: rgb(239, 68, 68);
    color: white;
}

[aria-expanded="true"]>.btn-outline-danger {
    background-color: rgb(239, 68, 68);
    color: white;
}

.btn-outline-light {
    background-color: transparent;
    color: rgb(15, 23, 42);
    border-width: 1px;
    border-color: #e0eaff;
}

.btn-outline-light:hover {
    border-color: #e0eaff;
    background-color: rgba(224, 234, 255, 0.05);
}

.btn-outline-light.active {
    background-color: #e0eaff;
    color: rgb(15, 23, 42);
}

[aria-expanded="true"]>.btn-outline-light {
    background-color: #e0eaff;
    color: rgb(15, 23, 42);
}

/* Light color variations */
.btn.light {
    background-opacity: 15%;
    --tw-ring-opacity: 0.3;
}

.btn-primary.light {
    color: rgb(25, 166, 157);
}

.btn-blue.light {
    color: rgb(59, 130, 246);
}

.btn-secondary.light {
    color: rgb(99, 102, 241);
}

.btn-success.light {
    color: rgb(34, 197, 94);
}
.bg-slate-200 {
    background-color: #edf2f7;
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-gradient-to-l {
  background-image: linear-gradient(to left, var(--tw-gradient-stops));
}
.bg-gradient-to-t {
  background-image: linear-gradient(to top, var(--tw-gradient-stops));
}
.bg-gradient-to-b {
  background-image: linear-gradient(to bottom, var(--tw-gradient-stops));
}

.from-primary\/5 {
  --tw-gradient-from: rgba(59, 130, 246, 0.05);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}

.to-blue-300\/5 {
  --tw-gradient-to: rgba(147, 197, 253, 0.05);
}
.rounded-\[2px\]  { border-radius: 2px; }
.rounded-\[4px\]  { border-radius: 4px; }
.rounded-\[5px\]  { border-radius: 5px; }
.rounded-\[6px\]  { border-radius: 6px; }
.rounded-\[8px\]  { border-radius: 8px; }
.rounded-\[10px\] { border-radius: 10px; }
.rounded-\[12px\] { border-radius: 12px; }
.rounded-\[16px\] { border-radius: 16px; }
.rounded-\[20px\] { border-radius: 20px; }
.border-slate-100 { border-color: #f1f5f9; }
.border-slate-200 { border-color: #e2e8f0; }
.border-slate-300 { border-color: #cbd5e1; }
.border-slate-400 { border-color: #94a3b8; }
.border-slate-500 { border-color: #64748b; }
.border-slate-600 { border-color: #475569; }
.border-slate-700 { border-color: #334155; }
.border-slate-800 { border-color: #1e293b; }
.border-slate-900 { border-color: #0f172a; }
.-top-3 {
  top: -0.75rem;
}
.from-primary {
  --tw-gradient-from: #3b82f6; /* مثال primary (blue-500) */
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.hover\:to-blue-600:hover {
  --tw-gradient-to: #2563eb;
}
.hover\:bg-slate-300:hover {
  background-color: #cbd5e1;
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.bg-primary {
  background-color: #01a753; /* مثال primary (blue-500) */
}
.hover\:bg-primary:hover {
  background-color: #01a753;
}
.bg-green-50 {
  background-color: #f0fdf4;
}
.py-1\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}

.min-w-\[16px\] { min-width: 16px; }
.min-w-\[24px\] { min-width: 24px; }
.min-w-\[32px\] { min-width: 32px; }
.min-w-\[40px\] { min-width: 40px; }
.min-w-\[48px\] { min-width: 48px; }


.left-4 {
  left: 1rem;
}
.to-blue-500 {
  --tw-gradient-to: #3b82f6;
}
.hover\:from-primary\/90:hover {
  --tw-gradient-from: rgba(59, 130, 246, 0.9);
}



.btn-info.light {
    color: #0ce7fa;
}

.btn-warning.light {
    color: #fa916b;
}

.btn-danger.light {
    color: rgb(239, 68, 68);
}

.btn-light.light {
    opacity: 0.8;
}

.africimg{
  display: inline-block;
  vertical-align: text-top;
  width: 15px;
}

.affiliate-order tr{
  background: linear-gradient(90deg, #01a653d9, rgba(255, 91, 45, 0.04));
}
.affiliate-order tr:hover{
  background: linear-gradient(90deg, #01a653, rgb(255 91 45 / 37%));
}


.POD tr{
  background: linear-gradient(90deg, #e113ae, rgba(208, 20, 117, 0.16));
}
.POD tr:hover{
  background: linear-gradient(90deg, #bf0992, rgba(208, 20, 117, 0.37));
}
/* .affiliate-order:before {
  content: "";
  z-index: -1;
  overflow: hidden;
  transform: rotate(-135deg);
  width: 120px;
  display: block; 
  background: #d3362d;
  background: linear-gradient(#bb2f28 0%, #e57368 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 34px;
  left: -16px;
  clip-path: polygon(120px 20px, 90px -10px, 30px -10px, 0px 20px, 10px 30px,  110px 30px);
  height: 20px;
  width: 120px;
}
.affiliate-order:after {
  content: "affiliate";
  z-index: 1;
  overflow: hidden;
  font-size: 10px;
  font-weight: bold;
  color: #FFF;
  text-transform: uppercase;
  text-align: center;
  line-height: 20px;
  transform: rotate(-50deg);
  width: 120px;
  display: block; 
  background: #d3362d;
  background: linear-gradient(#bb2f28 0%, #e57368 100%);
  box-shadow: 0 3px 10px -5px rgba(0, 0, 0, 1);
  position: absolute;
  top: 20px; left: -30px;
  clip-path: polygon(120px 20px, 90px -10px, 30px -10px, 0px 20px, 10px 30px,  110px 30px)
} */

.bx--inline-notification {
  max-width: 100% !important;
  border-left: 3px solid #09b02a;
  background: #01a65324;
  line-height: 1.625rem;
  color: #161616;
  -ms-flex-wrap: nowrap;
  flex-wrap: nowrap;
}
.bx--inline-notification {
  position: relative;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  width: 100%;
  min-width: 18rem;
  height: auto;
  min-height: 3rem;
}
.bx--inline-notification--low-contrast::before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  border-width: 1px 1px 1px 0;
  border-style: solid;
  content: '';
  -webkit-filter: opacity(0.4);
  filter: opacity(0.4);
  pointer-events: none;
  border-color: #09b02a;
}
.bx--inline-notification__details {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-flex: 1;
  -ms-flex-positive: 1;
  flex-grow: 1;
  margin: 0 1rem;
  line-height: 1.625rem;
  overflow-x: auto !important;
overflow-y: hidden !important;
}
.bx--inline-notification__icon {
  -ms-flex-negative: 0;
  flex-shrink: 0;
  margin-top: .875rem;
  margin-right: 1rem;
  fill: #09b02a;
}
.bx--inline-notification__text-wrapper {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding: .9375rem 0;
  line-height: 1.625rem;
}
.bx--inline-notification__subtitle {
  font-size: 1rem;
font-weight: 400;
line-height: 1.5;
letter-spacing: 0;
  word-break: break-word;
}
.bx--inline-notification__title {
  display: inline !important;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  letter-spacing: 0;
  font-weight: bold;
  margin: 0 .25rem 0 0;
  padding-bottom: 1rem;
  padding-top: 1rem;
}

.no-arrow-select select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: -1px;
  text-align: center;
}
.input-group-1 {
    position: relative;
    display: table;
    border-collapse: separate;
}
.input-group-addon {
    padding: 6px 25px;
    font-weight: normal;
    line-height: 1;
    color: #555;
    text-align: center;
    background-color: #eee;
    border: 1px solid #ccc;
    border-radius: 3px;
    border-left: 0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    width: 1%;
    white-space: nowrap;
    vertical-align: middle;
    display: table-cell;
}
.offers-card{
    transition: all .5s ease-in-out;
    position: relative;
    border-radius: 0.5rem;
    box-shadow: none;
    border: 1px solid rgba(0, 0, 0, 0.3);
    padding: 5px;
    background-color: rgb(235 175 2 / 10%);
    border-color: #eaae03;
}
.select-status{
   border-radius: 6px;
    padding: 8px 15px;
    display: table-cell;
    position: relative;
    float: left;
    margin-bottom: 0;
    text-align: center;
}
.select-status:hover{
  background-color: #e6e9eb;
}
.offers .commis_affiliate:not(:last-child){
  border-bottom: 1px dashed #7b7878;
  padding-bottom: 6px;
}
.offre-stock{
    border: 1px solid #515151;
    border-radius: 5px;
    margin-top: 5px;
    padding-left: 5px;
    padding-right: 5px;
}
.affiliates .expandable-image img{
    height: 6rem;
    width: 6rem;
}
.tag-img{
  width: 17px;
}
.commis_affiliate{
  display: flex;
  flex-direction: column;
  row-gap: .25rem;
}
.commis_affiliate .h-10 {
  height: .625rem;
}
.-mt10{
  margin-top: -10px;
}
.marque-top{
  height: 1.5rem;
  width: fit-content;
  border-radius: .25rem;
  padding-left: .5rem;
  padding-right: .5rem;
  font-size: 13px;
  line-height: 15px;
  padding: 4px 5px;
}

.aff-req-cpa-badge {
  display: inline-block;
  background: linear-gradient(135deg, #2563eb, #1d4ed8);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 3px 10px;
  border-radius: 4px;
}
.livechat-icon{
  position: fixed;
  bottom: 64px;
  right: 30px;
  z-index: 999999999999;
  height: 50px;
  width: 50px;
}

.livechat-icon>img {
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.livechat-icon .notif-count {
  position: absolute;
  top: 0;
  right: 0;
  height: 21px;
  width: 21px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #FFF;
  border-radius: 50%;
  background: rgb(50, 209, 148);
}

.expandable-profil img {
  width: auto !important;
  height: auto !important;
  border: 2px solid #bfc4ca;
  border-radius: 6%;
}

.notification-time {
  font-size: 12px;
  line-height: 1.35;
  color: #9fa1a2;
}

.flex-grow-1 {
  flex-grow: 1;
}

/* WebKit Scrollbar */
.vm2_body::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  /* width of the scrollbar */
}

/* Track */
.vm2_body::-webkit-scrollbar-track {
  background: #f1f1f1;
  margin: 0 30px;
  /* color of the track */
}

/* Handle */
.vm2_body::-webkit-scrollbar-thumb {
  background: #aba9a9;
  /* color of the handle */
  border-radius: 6px;
  /* roundness of the handle */
}

/* Handle on hover */
.vm2_body::-webkit-scrollbar-thumb:hover {
  background: #8f8f8f;
  /* color of the handle on hover */
}

.notification-bell {
  -webkit-animation: bell 1s 1s both infinite;
  animation: bell 1s 1s both infinite;
}

@-webkit-keyframes bell {
  0% {
    transform: rotate(0);
  }

  10% {
    transform: rotate(30deg);
  }

  20% {
    transform: rotate(0);
  }

  80% {
    transform: rotate(0);
  }

  90% {
    transform: rotate(-30deg);
  }

  100% {
    transform: rotate(0);
  }
}

@keyframes bell {
  0% {
    transform: rotate(0);
  }

  10% {
    transform: rotate(30deg);
  }

  20% {
    transform: rotate(0);
  }

  80% {
    transform: rotate(0);
  }

  90% {
    transform: rotate(-30deg);
  }

  100% {
    transform: rotate(0);
  }
}

.isnewnotif a {
  background-color: bisque;
}

.isrtl .ql-editor {
  text-align: right !important;
  direction: rtl;
}

.ql-editor {
  min-height: 140px !important;
}

.ql-snow .ql-formats:nth-child(3),
.ql-snow .ql-formats:nth-child(4),
.ql-snow .ql-formats:nth-child(5),
.ql-snow .ql-formats:nth-child(6),
.ql-snow .ql-formats:nth-child(7),
.ql-snow .ql-formats:nth-child(8),
.ql-snow .ql-formats:nth-child(9) {
  display: none !important;
}

.inner-cod {
  display: flex;
  overflow: hidden;
}

.mess-cod {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 30px;
  animation: slide-left 20s linear infinite;
  transition: all .3s ease;
  flex: 0 0 100%;
  text-decoration: none;
  letter-spacing: -0.01em;
  text-align: center;
  font-size: 15px;
  line-height: 20px;
  font-weight: 600;
}

.isrtl .mess-cod {
  animation: slide-right 20s linear infinite;
  direction: rtl;
}

.alert-cod .inner-cod:hover .mess-cod {
  animation: initial;
}

.alert-cod {
  justify-content: center;
  display: flex;
  align-items: center;
  box-shadow: 0px 2px 0px 0px #000000;
  border-radius: inherit !important;
  min-height: 56px;
  padding: 0 50px 0 30px;
  font-size: 14px;
  transition: transform 350ms ease-in-out;
  color: white;
  background: linear-gradient(90deg, #ffa91a 0%, #e24e86 33.85%, #a146ba 65.62%, #5896f4 100%);
  animation: bg-run 8s linear infinite;
  background-size: 150%;
  white-space: nowrap;
  color: #fff;
}

.preview .alert-cod {
  min-height: 45px;
  padding: 10px;
}

.alert-cod .close-button-notif {
  background: none;
  border: none;
  outline: none;
  position: absolute;
  top: calc(50% - 2px);
  right: 13px;
  transform: translateY(-50%);
  font-size: 15px;
  font-weight: lighter;
  color: currentColor;
  cursor: pointer;
  line-height: 0;
}

.alert-cod .close-button-notif svg {
  width: 12px;
  height: 12px;
}

.alert-cod svg {
  fill: #f5f1f1;
}

@-webkit-keyframes slide-left {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-100%);
  }
}

@keyframes slide-left {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-100%);
  }
}

@-webkit-keyframes slide-right {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes slide-right {
  from {
    transform: translateX(-100%);
  }

  to {
    transform: translateX(0);
  }
}

@keyframes bg-run {
  0% {
    background-position: 0;
  }

  50% {
    background-position: 100%;
  }

  100% {
    background-position: 0;
  }
}

.alert-fixed {
  position: fixed;
  top: 0px;
  left: 0px;
  width: 100%;
  z-index: 9999;
  border-radius: 0px;
}

.alert-absolute {
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  border-radius: 0px;
}

.alert-info {
  color: white;
  background-color: #e6840f;
  border-color: #703f03;
}

.alert {
  padding: 15px;
  margin-bottom: 20px;
  border: 1px solid transparent;
  border-radius: 4px;
}

.mainta button.close {
  -webkit-appearance: none;
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0;
}

.mainta .close {
  float: right;
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
  color: #eee8e8;
  text-shadow: 0 1px 0 #fff;
  filter: alpha(opacity=20);
}

.btn-whats {
  position: absolute;
  top: -15px;
  right: -26px;
  cursor: pointer;
}

.btn-whats img {
  height: 30px;
  width: 30px;
}

.invoice-detail-body .content-block {
  padding-left: 48px;
  padding-right: 48px;
}

.invoice-totals-container {
  position: relative;
  width: 100%;
  margin-top: 8px;
  overflow: auto;
}

.invoice-totals-container .invoice-totals-row.desktop {
  padding-right: 40px;
}

.invoice-totals-container .invoice-totals-row {
  width: 100%;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-pack: end;
  justify-content: flex-end;
}

.invoice-totals-container .invoice-summary-label {
  margin-left: 0;
  text-align: right;
}

.invoice-totals-container .invoice-totals-row.desktop .invoice-summary-value {
  padding: 0 0.25rem;
}

.invoice-totals-container .invoice-summary-value {
  min-width: 130px;
  text-align: right;
}

.invoice-totals-container .invoice-totals-row.bold {
  font-weight: 500;
  font-size: 1.1rem;
}

.invoice-detail-body .content-block {
  padding-left: 48px;
  padding-right: 48px;
}

.invoice-item-list .table {
  margin-bottom: 0;
}

.invoice-item-list .table {
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.invoice-item-list table {
  border-collapse: collapse;
}

.invoice-item-list table thead tr {
  text-transform: uppercase;
  padding: 0.8rem 0;
  font-weight: 700;
  border-top: 1px solid;
  border-bottom: 1px solid;
  font-size: 1rem;
}

.invoice-item-list .table th.invoice-detail-margin {
  width: 8px;
  max-width: 8px;
}

.invoice-item-list .table th {
  text-align: right;
}

.invoice-item-list .table th {
  padding: 0.7rem 0.5rem;
  border: none;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
  vertical-align: top;
  background: #3182ce4f;
}

.invoice-item-list .table th.invoice-detail-summary {
  text-align: left;
  width: 100%;
}

.invoice-item-list .table th {
  padding: 0.7rem 0.5rem;
  border: none;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
}

.invoice-items tr {
  border-bottom: 1px dashed #7b7878;
}

.item-row {
  -webkit-transition: -webkit-transform .5s ease-out;
  transition: -webkit-transform .5s ease-out;
  -o-transition: transform .5s ease-out;
  transition: transform .5s ease-out;
  transition: transform .5s ease-out, -webkit-transform .5s ease-out;
}

.invoice-item-list .table td {
  border: none;
  padding-top: 8px;
  padding-bottom: 0;
  text-align: center;
  vertical-align: middle;
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  padding: 0.25rem;
  text-align: left
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  vertical-align: top;
}

.item-row-amount,
.item-row-quantity,
.item-row-rate {
  text-align: right;
  min-width: 120px;
}

.item-row .item-row-actions {
  width: 50px;
}

.font-bold-imp {
  font-weight: 700 !important;
}

#tagsbuttons {
  display: block !important;
}

.py-0-imp {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.inline-block-imp {
  display: inline-block !important;
}

.invoice-table tbody:last-child {
  border: none;
}

.invoice-table .table>tbody {
  vertical-align: inherit;
}

.invoice-table .table-nowrap td,
.invoice-table .table-nowrap th {
  white-space: nowrap;
}

.invoice-table .table th {
  font-weight: 500;
  text-align: left;
  font-size: 15px;
}

.invoice-table .table-borderless>:not(caption)>*>* {
  border-bottom-width: 0;
}

.tab-pay {
  border: 2px dashed #585b5c !important;
  padding: 15px;
}

.app-theme .btn.btn-prime {
  background: #444;
  background: linear-gradient(#555, #444);
  color: #fff;
}

.app-theme .btn {
  font-size: 11px;
  font-weight: 500;
  color: #555;
  background: #f4f4f4;
  background: linear-gradient(#f4f4f4, #e4e4e4);
  border-radius: 3px;
  border: 1px solid #999;
  display: inline-block;
  padding: 4px;
  overflow: hidden;
  text-decoration: none;
  min-width: 30px;
  cursor: pointer;
  transition: ease-in .1s;
}

svg:not(:root).svg-inline--fa_2 {
  overflow: visible;
}

.svg-inline--fa_2 {
  display: inline-block;
  font-size: inherit;
  height: 15px;
  width: 15px;
  overflow: visible;
  vertical-align: sub;
}

.invoice-table .table-sm>:not(caption)>*>* {
  padding: 0.3rem 0.25rem;
}

.invoice-table .bg-light {
  background-color: #f3f6f9;
}

.invoice-table .border-0 {
  border: 0 !important;
}

.invoice-table .form-control {
  display: block;
  width: 100%;
  padding: 0.3rem 0.7rem;
  font-size: .825rem;
  font-weight: 400;
  line-height: 1.5;
  color: #212529;
  background-color: #d9e4ef;
  background-clip: padding-box;
  border: 1px solid #ced4da !important;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  border-radius: 0.25rem;
  -webkit-transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
  transition: border-color .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out, -webkit-box-shadow .15s ease-in-out;
}

.mx-input {
  border: none;
  box-shadow: none;
}

.multi-range-slider-bar-only .bar-inner {
  background-color: #05e27c !important;
}

.status-war .vs__selected {
  font-size: 10px;
  font-weight: 600;
}

.show-menu .btn-bottom-toolbar {
  width: 87%;
  padding-right: 25px;
}

.btn-bottom-toolbar {
  position: fixed;
  bottom: 0;
  padding: 12px;
  width: 100%;
  box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
  background: #fff;
  z-index: 60;
  border-top: 1px solid #ededed;
}

.text-total-m {
  background-color: rgb(148 148 148);
  line-height: .95;
  padding: 0.35em 0.65em;
  font-size: 0.7em;
  font-weight: 700;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25em;
  color: rgb(248 248 246);
  display: inline-block;
}

.vue-circular-progress .circle__svg {
  display: inline-block;
}

.rounded-circle {
  border-radius: 50% !important;
}

.font-bold-imp {
  font-weight: 700 !important;
}

.empty-row {
  background: repeating-linear-gradient(53deg, #bfc0c2 4%, #fcfcff 11px 6%, #ffffff 10px 7%, #9d9c9c 15px);
}

.focus\:shadow-outline:focus {
  margin-right: 6px;
}

.bg-dauchete {
  background-color: #f75c03 !important;
}

.bg-refund {
  background-color: #D90368 !important;
}

.bg-previous {
  background-color: #820263 !important;
}

.badge-soft-success {
  color: #e8bc52;
  background-color: rgba(232, 188, 82, .1);
  display: inline-block;
  padding: 2px 2px;
  font-size: 14px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 10px;
}

.videos iframe {
  margin: auto;
}

.rwd-media {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 56.25%;
  /* 16:9 */
}

.rwd-media iframe,
.rwd-media video {
  position: absolute;
  width: 100%;
  height: 100%;
}

.ware-primary {
  background: linear-gradient(90deg, rgb(255 91 45 / 31%), rgb(255 91 45 / 10%));
}

.ware-parentt {
  background: linear-gradient(90deg, rgb(255 91 45 / 13%), rgb(255 91 45 / 2%));
}

@keyframes blinkdot {
  0% {
    opacity: .2;
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: .2;
  }
}

.loading-excel span {
  animation-name: blinkdot;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  font-weight: 900;
  vertical-align: text-bottom;
}

.loading-excel span:nth-child(2) {
  animation-delay: .2s;
}

.loading-excel span:nth-child(3) {
  animation-delay: .4s;
}

.animation-pulse {
  -webkit-animation: shadow-pulse 1s infinite;
  animation: shadow-pulse 1s infinite;
}

@keyframes shadow-pulse {
  0% {
    box-shadow: 0 0 0 0px rgba(30, 112, 185);
  }

  100% {
    box-shadow: 0 0 0 15px rgba(0, 0, 0, 0);
  }
}

.exp-expedition {
  background: linear-gradient(90deg, rgb(247 165 68 / 52%), rgb(240 162 70 / 0%));
}

.exp-transfer {
  background: linear-gradient(90deg, rgb(113 226 245 / 64%), rgb(102 223 243 / 18%));
}

.exp-prime {
  background: linear-gradient(90deg, rgb(16 141 61 / 42%), rgb(16 141 61 / 5%));
}

.exp-avance {
  background: linear-gradient(90deg, rgb(243 42 84 / 38%), rgb(243 158 176 / 28%));
}

.aff-row-cpa {
  background: linear-gradient(90deg, rgb(37 99 235 / 22%), rgb(37 99 235 / 5%));
}

.aff-row-affiliate {
  background: linear-gradient(90deg, rgb(5 150 105 / 22%), rgb(5 150 105 / 5%));
}

.ware_prin {
  position: relative;
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 15px;
  box-sizing: border-box;
  margin-left: 7px;
}

.ware_prin::before {
  position: absolute;
  top: 47px;
  left: 0;
  width: 53px;
  height: 1px;
  margin: auto;
  content: "";
  background-color: #666;
}

.ware_prin::after {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  height: 48px;
  width: 1px;
  content: "";
  background-color: #666;
}

.mll-4 {
  margin-left: 4em;
}

.data-ss {
  border: 2px dashed #858585;
  border-radius: 8px;
  background-color: rgba(255, 255, 255, 1);
  font-size: 12px;
  line-height: 1.28;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  box-sizing: border-box;
  position: relative;
  padding: 15px;
  overflow-x: auto;
  overflow-y: auto;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: column;
}

.row-data {
  margin-bottom: 8px;
  margin-top: 5px;
}

.row-data .title-1 {
  font-weight: 400;
  word-wrap: normal;
  color: rgba(0, 0, 0, .85);
  white-space: inherit;
  font-size: .875rem !important;
}

.row-data .content-1 {
  text-align: left;
  color: rgba(0, 0, 0, .75);
  font-weight: 700;
  word-wrap: normal;
  font-size: .875rem !important;
}

.header-1 {
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
  flex-direction: row;
  display: flex;
  font-size: 12px;
  line-height: 1.28;
}

.header-1 .content {
  box-sizing: border-box;
  height: 60px;
}

.header-1 .title {
  white-space: nowrap;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  text-align: left;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, .75);
  font-weight: 700;
  font-size: 1.125rem !important;
  line-height: 1.33334 !important;
}

.header-1 .content-1 {
  white-space: nowrap;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: hidden;
  font-weight: normal;
  text-overflow: ellipsis;
  color: rgba(0, 0, 0, .75);
  word-wrap: normal;
  line-height: 1.42858 !important;
  font-size: .875rem !important;
}

.header-table {
  width: 100%;
  display: flex;
  align-items: center;
  height: 48px;
  box-sizing: border-box;
  padding-top: 10px;
  padding-bottom: 10px;
  box-shadow: inset 0 -1px 0 #dadcde;
  border-top: 1px solid #CECDCD;
}

.header-table .title {
  display: flex;
  align-items: center;
  min-width: 0;
  text-align: left;
  color: rgba(0, 0, 0, .75);
  font-weight: 700;
  word-wrap: normal;
  line-height: 1.42858;
  white-space: inherit;
  font-size: .875rem;
}

.header-table .title-1 {
  font-weight: 400 !important;
}

.xz84dc7 {
  width: 60%;
}

.x8yj6t5 {
  width: 20%;
}

.x8yj6t5 {
  width: 20%;
}

.mb-14 {
  margin-bottom: 5rem;
}

hr:not([size]) {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 0px;
  border-left: none;
  border-bottom: 2px solid #01a653;
}

.avatar-xs {
  height: 2rem;
  width: 2rem;
}

.rounded-circle {
  border-radius: 50% !important;
}

.align-items-center {
  -webkit-box-align: center !important;
  -ms-flex-align: center !important;
  align-items: center !important;
}

.d-flex {
  display: -webkit-box !important;
  display: -ms-flexbox !important;
  display: flex !important;
}

.me-2 {
  margin-right: 0.5rem !important;
}

.flex-shrink-0 {
  -ms-flex-negative: 0 !important;
  flex-shrink: 0 !important;
}

.flex-grow-1 {
  -webkit-box-flex: 1 !important;
  -ms-flex-positive: 1 !important;
  flex-grow: 1 !important;
}

.call-post {
  border: 2px solid #959292;
  border-style: dashed;
  padding: 1px;
  border-radius: 5%;
  font-size: 10px;
  font-weight: 600;
  align-items: center;
  justify-content: center;
  line-height: 1px;
  margin-top: 2px;
}

.vue-circular-progress .percent__int {
  font-size: 16px !important;
}

.mb-130 {
  margin-bottom: 130px;
}

@keyframes blinkdot {
  0% {
    opacity: .2;
  }

  20% {
    opacity: 1;
  }

  100% {
    opacity: .2;
  }
}

.loading-excel span {
  animation-name: blinkdot;
  animation-duration: 1.4s;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  font-weight: 900;
  vertical-align: text-bottom;
}

.loading-excel span:nth-child(2) {
  animation-delay: .2s;
}

.loading-excel span:nth-child(3) {
  animation-delay: .4s;
}

#vm2_box_ModalChangeStatus .s-sidebarwidget {
  margin-bottom: 80px;
}

#vm2_box_modalConfirm .vm2__close,
#vm2_box_Params .vm2__close,
#vm2_box_upsell .vm2__close,
#vm2_box_ModalChangeStatusByDauchette .vm2__close,
#vm2_box_RefreshPage .vm2__close,
#vm2_box_ModalPay .vm2__close,
#vm2_box_warehouseParent .vm2__close,
#vm2_box_smsSend .vm2__close,
#vm2_box_ModalRefunds .vm2__close,
#vm2_box_myModalSettings .vm2__close,
#vm2_box_myModalSettings .vm2__close,
#vm2_box_deletePayment .vm2__close{
  display: none;
}

.mx-datepicker {
  width: 100%;
}

.sucess {
  color: #1b9c0d;
}

.input-style {
  padding: 0.375rem 0.75rem;
  font-size: 0.9375rem;
  line-height: 1.6;
  color: #9493a9 !important;
  background-color: #f4f3f9;
  background-clip: padding-box;
  border: 1px solid #e1e0ea;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  border-radius: 3px;
}

.bg-dauch {
  border: 2px solid #dcdcde;
  border-radius: 0.25rem;
  background-color: #fff;
}

.w-full-imp {
  width: 100% !important;
}

.ant-row input:focus-visible+.ant-input-group-addon {
  outline: 2px solid rgb(72, 156, 248);
}

.ant-row {
  position: relative;
  height: auto;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  margin-bottom: 24px;
  zoom: 1;
  display: block;
  box-sizing: border-box;
  cursor: pointer;
}

.ant-label {
  display: inline-block;
  overflow: hidden;
  line-height: 39.9999px;
  white-space: nowrap;
  text-align: right;
  vertical-align: middle;
}

.ant-col {
  position: relative;
  min-height: 1px;
}

.ant-row label {
  position: relative;
}

.ant-label>label {
  color: rgba(0, 0, 0, .85);
}

.ant-form-item-control {
  position: relative;
  line-height: 40px;
  zoom: 1;
}

.ant-form-item-children {
  position: relative;
}

.ant-input-group-wrapper {
  display: inline-block;
  width: 100%;
  text-align: start;
  vertical-align: top;
}

.ant-input-group {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  color: #4d4d4d;
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  display: table;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-input[disabled] {
  background: rgb(247, 249, 250);
}

.ant-input-group>.ant-input:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.ant-input {
  height: 40px;
  float: left;
  width: 100%;
  margin-bottom: 0;
  text-align: inherit;
  touch-action: manipulation;
  -webkit-appearance: none;
  font-variant: tabular-nums;
  list-style: none;
  font-feature-settings: "tnum";
  position: relative;
  padding: 4px 11px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
  font-size: 14px;
  line-height: 1.5;
  border-collapse: separate;
  border-spacing: 0;
}

.ant-input-group-addon:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-left: 0;
}

.ant-input-group-addon {
  position: relative;
  padding: 0 11px;
  color: #4d4d4d;
  font-weight: 400;
  font-size: 14px;
  text-align: center;
  background-color: #fafafa;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
}

.ant-input-group-addon,
.ant-input-group-wrap {
  width: 1px;
  white-space: nowrap;
  vertical-align: middle;
}

.ant-input-group-addon,
.ant-input-group-wrap,
.ant-input-group>.ant-input {
  display: table-cell;
}

.svg-inline--fa.fa-w-14 {
  width: 0.875em;
}

.upload-dropzone-border {
  border: 0;
  background-image: url("data:image/svg+xml, %3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='4px' ry='4px' stroke='%2389888D' stroke-width='2' stroke-dasharray='6%2c4' stroke-dashoffset='0' stroke-linecap='butt' /%3e %3c/svg%3e");
  border-radius: 4px;
}

#loadingpage {
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: radial-gradient(circle at 50% 38%, #ffffff 0%, #f1fbf5 100%);
  z-index: 10000;
  animation: lpFade .28s ease;
}
/* Boîte centrée : logo + spinner + texte */
#loadingpage .lp-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  animation: lpRise .35s ease both;
}
#loadingpage .lp-logo {
  width: 150px;
  max-width: 60vw;
  height: auto;
  filter: drop-shadow(0 6px 16px rgba(1,166,83,.12));
}
#loadingpage .loader {
  position: static;
  z-index: 30;
  width: 92px;
  height: 92px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
#loadingpage .loader svg { width: 92px !important; height: 92px !important; }
#loadingpage .lp-dots i {
  display: inline-block;
  animation: lpBlink 1.4s infinite both;
}
#loadingpage .lp-dots i:nth-child(2) { animation-delay: .2s; }
#loadingpage .lp-dots i:nth-child(3) { animation-delay: .4s; }
@keyframes lpFade { from { opacity: 0; } to { opacity: 1; } }
@keyframes lpRise { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: none; } }
@keyframes lpBlink { 0%, 20% { opacity: 0; } 50% { opacity: 1; } 100% { opacity: 0; } }

#loadingpage .loader--dead {
  position: absolute;
  z-index: 30;
  left: 50%;
  width: 120px;
  margin-left: -65px;
  margin-bottom: 30px;
}

#loadingpage .loader .spinner-ball-outer,
.ecwid-loadingIndicator .loader .spinner-ball-outer {
  width: 88px;
  height: 88px;
  background: transparent url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='88' height='88' viewBox='0 0 88 88'%3E%3Cpath fill='none' stroke='%23275ce0' stroke-linecap='round' stroke-width='3' d='M64.8 79.5C58.4 83.3 51 85.5 43 85.5 27 85.5 13 76.6 5.8 63.5M64.4 6.2C77 13.6 85.5 27.3 85.5 43 85.5 50.7 83.4 58 79.8 64.2M.5 43C.5 19.5 19.5.5 43 .5' transform='translate(1 1)'/%3E%3C/svg%3E") center center no-repeat;
  background-size: contain;
  animation: spinright .8s infinite linear;
}

#loadingpage .loader .spinner-ball-inner,
.ecwid-loadingIndicator .loader .spinner-ball-inner {
  width: 40px;
  height: 40px;
  margin: -64px auto 64px;
  background: transparent url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 40 40'%3E%3Cpath fill='%23275ce0' d='M20 39.5C9.2 39.5.5 30.8.5 20S9.2.5 20 .5 39.5 9.2 39.5 20c0 .8-.7 1.5-1.5 1.5s-1.5-.7-1.5-1.5c0-9.1-7.4-16.5-16.5-16.5S3.5 10.9 3.5 20 10.9 36.5 20 36.5c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z'/%3E%3C/svg%3E") center center no-repeat;
  background-size: contain;
  animation: spinleft .5s infinite linear;
}

#loadingpage .loading-info {
  position: static;
  margin: 0;
  text-align: center;
  font-size: 15px;
  line-height: 22px;
  font-weight: 600;
  letter-spacing: .3px;
  color: #0f9d58;
}

.sous-s {
  color: #646878;
  background-color: #eff1f2;
  font-weight: 600;
  align-items: center;
  margin-top: 2px;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 5px;
  --bs-badge-padding-x: 0.5rem;
  --bs-badge-padding-y: 0.325rem;
  --bs-badge-font-size: 0.85rem;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #ffffff;
  --bs-badge-border-radius: 0.425rem;
  padding: 2px 4px;
  font-size: 10px;
}

body {
  position: relative;
  overflow: inherit !important;
}

.tag_cities {
  width: 100%;
  max-width: 100%;
}

.tag_cities .tag {
  background: rgb(49 130 206 / 16%);
  border-radius: 20px;
  float: left;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  font-size: 0.8rem;
  font-weight: 500;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-right: 2px;
  margin-bottom: 5px;
  min-height: 28px;
  padding-right: 10px;
  color: rgba(0, 0, 0, 0.7);
  position: relative;
  padding-right: 0;
}

.vs-chip--text {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  margin-left: 10px;
}

.vs-chip--close {
  width: 20px;
  height: 20px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  border-radius: 50%;
  border: 0;
  margin: 0 4px;
  cursor: pointer;
  background: rgba(0, 0, 0, 0.15);
  color: #fff;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  cursor: pointer;
}

.tag_cities .tag [data-role="remove"]::after {
  content: "x";
  padding: 0px 2px;
  margin-bottom: 3px;
  font-size: 15px;
}

.tag_cities .tag [data-role="remove"] {
  margin-left: 8px;
  cursor: pointer;
}

main {
  background-color: #f2f2f2;
}

.v-select .vs__selected {
  white-space: nowrap !important;
}

.v-select .vs__dropdown-toggle {
  overflow-x: hidden !important;
}
.paymentmethods .v-select {
 padding-top: 3px  !important;
  padding-bottom: 3px  !important;
}

.percent .percent__dec,
.percent .dot {
  display: none;
}

.vs__selected-options {
  flex-wrap: inherit;
}

.vue-circular-progress .circle__progress--path {
  stroke-opacity: 0.2 !important;
}

hr.hr-grey {
  margin-bottom: 0;
  margin-top: 5px;
  border-color: #706d6d;
}

hr.hr-grey {
  margin-bottom: 0;
  margin-top: 5px;
  border-color: #706d6d;
}

p.Note {
  font-size: 12px;
  background-color: #f6f6f6;
  padding: 11px;
  display: block;
  margin-bottom: 10px;
}

.table-messages {
  max-height: 500px;
  overflow: auto;
}

.table-messages th {
  font-size: 15px;
}

.error {
  color: #c62525;
}

.success {
  color: #25c631;
}

.warn {
  color: #ff9800;
}

.bg-error {
  background: #fdebeb;
}

.bg-success {
  background: #ccffd0;
}

.bg-warn {
  background: #fff8d1;
}

.tab-cc {
  /* padding: 10px;
    border-radius: 3px;
    box-shadow: 0 1px 3px 0 #c4c4c4;
    box-shadow: 0 1px 3px 0 rgb(0 0 0 / 15%);
    border: 0;
    background: #e1e1e1; */
}

.s-sidebarwidget__yellow {
  border-color: hsl(47deg 65% 84%);
  background-color: hsl(47deg 87% 94%);
}

.sidebarwidget__yellow .s-sidebarwidget--header,
.s-sidebarwidget__yellow .s-sidebarwidget--content {
  border-color: hsl(47deg 65% 84%);
}

.s-sidebarwidget--header.s-sidebarwidget__small-bold-text {
  font-size: 14px;
  font-weight: bold;
}

.s-sidebarwidget--header:first-child {
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
}

.s-sidebarwidget__yellow .s-sidebarwidget--header {
  background-color: #fbf3d5;
  color: #6b737c;
}

.s-sidebarwidget--item {
  margin: 12px 0;
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.fc-light {
  color: hsl(210deg 7% 44%) !important;
}

.bbw1 {
  border-bottom-width: 1px !important;
}

.bb {
  border-bottom-style: solid !important;
  border-bottom-width: 1px !important;
}

.s-sidebarwidget--header {
  padding: 12px 15px;
  background: hsl(0deg 0% 98%);
}

.s-sidebarwidget--header,
.s-sidebarwidget--content {
  border-top: 1px solid hsl(210deg 7% 89%);
}

.s-sidebarwidget {
  position: relative;
  border: 1px solid hsl(210deg 8% 85%);
  border-radius: 3px;
  font-size: 13px;
}

.intro-y {
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .2s;
  animation-delay: .2s;
}

.text-smmm {
  font-size: 9px;
}

.box-1 {
  background: #f2f4f7;
  border: 2px solid #e8ebed;
  border-radius: 0.375rem;
}

.loidingconfirm svg {
  width: 30px;
}

.noselect {
  pointer-events: none;
}

.seller-select .vs__dropdown-toggle {
  border: none;
}

.vs__dropdown-toggle {
  border: none;
}

.disabled {
  pointer-events: none;
  color: #bfcbd9;
  cursor: not-allowed;
  background-image: none;
  background-color: #eef1f6;
  border-color: #d1dbe5;
}

.disabled-loading {
  pointer-events: none;
  cursor: not-allowed;
}

.vm2_body .ins-progress {
  position: absolute !important;
}

.h-14 {
  height: 3.5rem !important;
}

.modal-footer {
  overflow: auto;
  position: absolute;
  bottom: 0;
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 -4px 1px -4px rgb(0 0 0 / 10%);
  border-top: 1px solid #ededed;
  padding-top: 15px;
  padding-bottom: 15px;
}

.mb-13 {
  margin-bottom: 4rem;
}

.mll-0 {
  margin-left: 0 !important
}

.vm2__header h4 {
  pointer-events: none;
}

.vm2__header h4,
.vm2__header .vm2__close {
  font-weight: 600;
}

.vm2_wrapper {
  z-index: 11;
}

.vm2_body {
  max-height: 500px;
  margin-right: 2px;
}

.text-green-600,
.text-green-500 {
  color: #01a653;
}

.bg-green-600,
.bg-green-700 {
  background-color: #01a653;
}

.hover\:bg-indigo-darker:hover {
  background-color: #2f365f;
}

.bg-indigo-darker {
  background-color: #2f365f;
}

.bg-indigo {
  background-color: #6574cd;
}

.hover\:bg-indigo:hover {
  background-color: #6574cd;
}

.flag-img {
  display: inline-block;
  height: 16px;
  width: 16px;
  vertical-align: text-top;
  line-height: 16px;
  margin-right: 5px;
}

.form-checkbox {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  -webkit-print-color-adjust: exact;
  color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  flex-shrink: 0;
  color: currentColor;
  background-color: #fff;
  border-color: #e2e8f0;
  border-width: 1px;
  border-radius: 0.25rem;
  height: 1.2em;
  width: 1.2em;
}

.form-checkbox:checked {
  background-image: url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586 5.707 7.293z'/%3e%3c/svg%3e");
  border-color: transparent;
  background-color: currentColor;
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

.alert-dialog {
  position: absolute;
  transform: translate(-50%, -50%);
  z-index: 9990;
  padding: 15px 25px;
  color: #444444;
  background-color: white;
  box-shadow: 0 15px 30px 5px #00000045;
  border-radius: 35px;
  cursor: pointer;
}

.alert-dialog.fadein {
  animation: fadein 1s;
}

.alert-dialog.fadeout {
  animation: fadeout 1s;
}

@keyframes fadein {
  0% {
    opacity: 0;
    transform: translate(-50%, 50%);
  }

  100% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}

@keyframes fadeout {
  0% {
    opacity: 1;
    transform: translate(-50%, -50%);
  }

  100% {
    opacity: 0;
    transform: translate(-50%, 50%);
  }
}

.intro-y {
  position: relative;
  transform: translateY(50px);
  -webkit-animation: intro-y-animation .4s ease-in-out .33333s;
  animation: intro-y-animation .4s ease-in-out .33333s;
  -webkit-animation-fill-mode: forwards;
  animation-fill-mode: forwards;
  -webkit-animation-delay: .2s;
  animation-delay: .2s
}

.zoom-in:hover {
  --tw-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04);
  box-shadow: 0 3px 20px rgba(0, 0, 0, .043137254901960784);
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05
}

.zoom-in {
  cursor: pointer;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  transform: translateX(var(--tw-translate-x)) translateY(var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, -webkit-backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-property: background-color, border-color, color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter, -webkit-backdrop-filter;
  transition-duration: .15s;
  transition-timing-function: cubic-bezier(.4, 0, .2, 1);
  transition-duration: .3s
}

.box {
  box-shadow: 0 3px 20px rgba(0, 0, 0, .043137254901960784);
  background-color: #fff;
  border-radius: .375rem;
}

.check {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
}

i.tiny {
  font-size: 12px;
  line-height: 20px;
}

.feather-icon {
  display: inline-flex;
  align-items: center;
}

.active .check {
  display: block;
}

.intro-y.active {
  border: 2px solid rgba(103, 240, 114, .9) !important;
  background: rgba(103, 240, 114, .1) !important;
}

/*  Mobile css */
.mat-icon-button {
  padding: 0;
  min-width: 0;
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  border-radius: 50%;
  box-sizing: border-box;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  outline: none;
  border: none;
  -webkit-tap-highlight-color: transparent;
  display: inline-block;
  white-space: nowrap;
  text-decoration: none;
  vertical-align: baseline;
  text-align: center;
  margin: 0;
  overflow: visible;
}

.loading-panel {
  position: absolute;
  top: 50%;
  left: 50%;
  min-width: 16em;
  min-height: 8.75em;
  margin-top: -4.3em;
  margin-left: -8em;
  font-size: 14px;
  animation: zoom .3s 1 linear, fadein .5s 1 linear;
}

.check {
  display: none;
  position: absolute;
  top: 5px;
  right: 5px;
}

.check-left {
  position: absolute;
  top: 5px;
  left: 5px;
}

.active .check-left {
  display: block;
}

i.tiny {
  font-size: 12px;
  line-height: 20px;
}

.feather-icon {
  display: inline-flex;
  align-items: center;
}

.bg-ww {
  border: 2px solid #77d7c8;
  background-color: #f5f5f5;
  padding: 15px;
  max-height: 270px;
  min-height: 240px;
  overflow-y: auto;
}

.box-1 {
  background: #f2f4f7;
  border: 2px solid #77d8c8;
  border-radius: .375rem;
}

.active .check {
  display: block;
}

.intro-y.active {
  border: 2px solid rgba(103, 240, 114, .9);
  background: rgba(103, 240, 114, .1);
}

.warehouse .zoom-in:hover {
  margin-left: 8px;
  margin-right: 8px;
}

.warhouseparent .parent-warehouse {
  padding-left: 35px;
}

/*  Mobile css */
.mat-icon-button {
  padding: 0;
  min-width: 0;
  width: 35px;
  height: 35px;
  flex-shrink: 0;
  border-radius: 50%;
  box-sizing: border-box;
  position: relative;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  cursor: pointer;
  outline: none;
  border: none;
  -webkit-tap-highlight-color: transparent;
  display: inline-block;
  white-space: nowrap;
  text-decoration: none;
  vertical-align: baseline;
  text-align: center;
  margin: 0;
  overflow: visible;
}

.tinytabs {
  margin-top: 10px;
}

.tinytabs .section .title {
  display: none;
}

.tinytabs .tabs {
  margin-left: 15px;
  display: flex;
  flex-flow: row wrap;
}

.tinytabs .tabs .tab .close {
  padding-left: 5px;
}

.tinytabs .tabs .tab {
  margin: 0 3px 0 0;
  background: #e1e1e1;
  display: block;
  padding: 6px 15px;
  text-decoration: none;
  color: #666;
  font-weight: bold;
  border-radius: 3px 3px 0 0;
  border: 1px solid black;
  border-bottom: none;
}

.tinytabs .section {
  background: #f1f1f12e;
  overflow: hidden;
  padding: 15px;
  clear: both;
  border-radius: 3px;
  min-height: 400px;
  border: 1px solid black;
}

.tinytabs .tab.sel {
  background: #f1f1f1;
  color: #333;
  text-shadow: none;
}


.tabs-component-tabs {
  border: solid 1px #504e4e;
  border-radius: 6px;
  margin-bottom: 5px;
}

@media (min-width: 700px) {
  .tabs-component-tabs {
    border: 0;
    align-items: stretch;
    display: flex;
    justify-content: flex-start;
    margin-bottom: -1px;
  }
}

.tabs-component-tab {
  color: #999;
  font-size: 14px;
  font-weight: 600;
  margin-right: 0;
  list-style: none;
}

.tabs-component-tab:not(:last-child) {
  border-bottom: dotted 1px #ddd;
}

.tabs-component-tab:hover {
  color: #666;
}

.tabs-component-tab.is-active {
  color: #000;
}

.tabs-component-tab.is-disabled * {
  color: #cdcdcd;
  cursor: not-allowed !important;
}

@media (max-width: 700px) {
  .topbar-notifs{
    margin-left: auto;
  }
  .topbar-notifs .item-topbar{
    display: inline-block;
  }
  .hide-mobile{
    display: none !important;
  }
  .topbar-notifs ul{
    align-items: center;
    justify-content: center;
    display: flex;
    flex-direction: inherit;
  }
  .topbar-notifs .topbar-country .vs-dropdown--menu{
    width: 150px;
  }
}


@media (max-width: 580px) {
 .topbar-country button{
    margin-top: 0;
    padding-top: 0;
    padding-bottom: 0;
 }
 .title-balance{
  font-size: 15px;
 }
 .img-balances {
  height: 50px !important;
}
 .top-bar-dashboard,.user-bar .title,.add-project-link .categories-content {
    display: none;
 }
 .dashboard-link{
  margin-left: 5px;
 }
}

@media (min-width: 700px) {
 
  .tabs-component-tab {
    background-color: #fff;
    border: solid 1px #504e4e;
    border-radius: 3px 3px 0 0;
    margin-right: .5em;
    transform: translateY(2px);
    transition: transform .3s ease;
  }

  .tabs-component-tab.is-active {
    border-bottom: solid 1px #fff;
    z-index: 2;
    transform: translateY(0);
  }
}

.tabs-component-tab-a {
  align-items: center;
  color: inherit;
  display: flex;
  padding: .75em 1em;
  text-decoration: none;
}

.tabs-component-panels {
  padding: 1em 0;
}

@media (min-width: 700px) {
  .tabs-component-panels {
    border-top-left-radius: 0;
    background-color: #fff;
    border: solid 1px #504e4e;
    border-radius: 0 6px 6px 6px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .05);
    padding: 1em 1em
  }
}

.invoice-item-list .table {
  margin-bottom: 0;
  width: 100%;
  margin-bottom: 1rem;
  color: #212529;
}

.invoice-item-list table {
  border-collapse: collapse;
}

.invoice-item-list table thead tr {
  text-transform: uppercase;
  padding: 0.8rem 0;
  font-weight: 700;
  border-top: 1px solid;
  border-bottom: 1px solid;
  font-size: 1rem;
}

.invoice-item-list .table th.invoice-detail-margin {
  width: 8px;
  max-width: 8px;
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  padding: 0.25rem;
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  text-align: left;
  vertical-align: top;
}

.invoice-item-list .table th {
  padding: 0.7rem 0.5rem;
  border: none;
  font-weight: 500;
  -webkit-font-smoothing: antialiased;
}

.invoice-item-list .table th {
  text-align: right;
  vertical-align: top;
  background: rgba(49, 130, 206, .31);
}

.invoice-item-list .table td.item-row-summary,
.invoice-item-list .table th.invoice-detail-summary {
  text-align: left;
  width: 50%;
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  text-align: left;
  vertical-align: top;
}

.invoice-items tr {
  border-bottom: 1px dashed #7b7878;
}

.item-row {
  transition: transform .5s ease-out;
}

.item-row .item-row-actions {
  width: 50px;
}

.item-row .item-row-actions .btn {
  min-width: 35px;
  padding: 4px;
}

.item-row .btn {
  -webkit-font-smoothing: antialiased;
  font-weight: 500;
  color: #555;
  background: #f4f4f4;
  background: linear-gradient(#f4f4f4, #e4e4e4);
  border-radius: 3px;
  border: 1px solid #999;
  display: inline-block;
  padding: 4px;
  overflow: hidden;
  text-decoration: none;
  min-width: 34px;
  cursor: pointer;
  transition: .1s ease-in;
  font-size: inherit;
}

.svg-inline--fa.fa-w-11 {
  width: 0.6875em;
}

.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}

.item-row-name {
  display: block;
}

.invoice-items tr.item-row-n {
  border: none;
}

.item-row {
  transition: transform .5s ease-out;
}

.invoice-item-list .table td,
.invoice-item-list .table th {
  padding: 0.25rem;
}

.item-row .item-row-actions {
  width: 50px;
}

.item-row .btn.btn-prime {
  background: #444;
  background: linear-gradient(#555, #444);
  color: #fff;
  font-weight: 500;
}

.item-row .item-row-actions .btn {
  min-width: 35px;
  padding: 4px;
}

.item-row .btn {
  -webkit-font-smoothing: antialiased;
  font-weight: 500;
  color: #555;
  background: #f4f4f4;
  background: linear-gradient(#f4f4f4, #e4e4e4);
  border-radius: 3px;
  border: 1px solid #999;
  display: inline-block;
  padding: 4px;
  overflow: hidden;
  text-decoration: none;
  min-width: 30px;
  cursor: pointer;
  transition: .1s ease-in;
  font-size: inherit;
}

/* chat messages */
#vm2_box_chatMessages {
  background-color: #f7f7f7 !important;
}

.message-view {
  display: table-cell;
  height: 100%;
  float: none;
  padding: 0;
  position: static;
  vertical-align: top;
  width: 75%;
}

.chat-window {
  display: table;
  height: 100%;
  table-layout: fixed;
  width: 100%;
  background-color: #f7f7f7;
}

.chat-contents {
  display: table-row;
  height: 100%;
}

.chat-contents .chat-content-wrap {
  height: 100%;
  position: relative;
  width: 100%;
}

.chat-content-wrap .chat-wrap-inner {
  overflow: auto;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.chat-content-wrap .chat-wrap-inner .chats {
  padding: 15px 15px 30px;
  padding-top: 0px;
  margin-top: -20px;
  overflow: hidden;
  overflow-y: scroll;
  height: 435px;
  margin-bottom: 25px;
}

.chat-contents .chat-content-wrap .chats .chat-right .chat-body {
  padding: 0 10px 0 48px;
}

.chat-contents .chat-content-wrap .chats .chat-bubble {
  display: block;
  width: 100%;
  float: left;
  margin-bottom: 10px;
}

.chat-contents .chat-content-wrap .chats .chat-right .chat-body .chat-content {
  background-color: #F2F3F4;
  border: 1px solid #E2E4E6;
  clear: both;
  color: #646669;
  display: block;
  float: right;
  max-width: 60%;
  position: relative;
  margin: 0;
  padding: 8px 15px;
  border-radius: 20px 2px 2px 20px;
}

.chat-contents .chat-content-wrap .chats .chat-bubble:last-child .chat-content {
  border-bottom-right-radius: 20px !important;
}

.chat-contents .chat-content-wrap .chats .chat-bubble:first-child .chat-content {
  border-top-right-radius: 20px !important;
}

.chat-contents .chat-content-wrap .chats .chat-bubble .chat-content p {
  margin: 0;
}

.chat-contents .chat-content-wrap .chats .chat-right .chat-body .chat-content .chat-time {
  text-align: right;
}

.chat-contents .chat-content-wrap .chats .chat-bubble .chat-content .chat-time {
  color: rgba(0, 0, 0, 0.5);
  display: block;
  font-size: 12px;
}

.chat-line {
  border-bottom: 1px solid #E9E9EA;
  position: relative;
  text-align: center;
  width: 100%;
  margin: 7px 0 20px;
}

.chat-line .chat-date {
  background-color: #f7f7f7;
  color: #646669;
  font-size: 12px;
  padding: 0 11px;
  position: relative;
  top: 10px;
  left: -15px;
}

.chat-contents .chat-content-wrap .chats .chat-left {
  width: 100%;
  float: left;
}

.chat-contents .chat-content-wrap .chats .chat-left .chat-avatar {
  float: left;
}

.chat-contents .chat-content-wrap .chats .chat-left .chat-avatar .avatar {
  line-height: 30px;
  height: 32px;
  width: 32px;
}

.chat-contents .chat-content-wrap .chats .chat-left .chat-body {
  margin: 0;
  padding: 0 20px 0 0;
  display: block;
  overflow: hidden;
}

.chat-contents .avatar {
  background-color: transparent;
  color: #FFF;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  position: relative;
  white-space: nowrap;
  margin: 0 10px 0 0;
  border-radius: 50%;
}

.chat-contents .avatar>img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}

.chat-contents .chat-content-wrap .chats .chat-left .chat-bubble:first-child .chat-content {
  border-top-left-radius: 20px;
}

.chat-contents .chat-content-wrap .chats .chat-bubble:first-child .chat-content {
  border-top-right-radius: 20px !important;
}

.chat-contents .chat-content-wrap .chats .chat-left .chat-content {
  background-color: #FFF;
  border: 1px solid #E9E9EA;
  color: #7A7C7F;
  float: left;
  position: relative;
  max-width: 60%;
  padding: 8px 15px;
  border-radius: 2px 20px 20px 2px;
}

.chat-main-wrapper {
  display: table;
  height: 500px;
  table-layout: fixed;
  width: 100%;
}

.chat-main-row {
  overflow: auto;
  padding-bottom: inherit;
  padding-top: inherit;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.chat-footer {
  background-color: #FFF;
  border-top: 1px solid #E9E9EA;
  padding: 15px;
}

.chat-footer .message-bar {
  display: table;
  height: 44px;
  position: relative;
  width: 100%;
}

.chat-footer .message-bar .message-inner {
  display: table-row;
  height: 100%;
  width: 100%;
}

.chat-footer .message-bar .link2 {
  color: #7A7C7F;
  display: table-cell;
  font-size: 20px;
  position: relative;
  vertical-align: middle;
  width: 30px;
  text-decoration: none;
  outline: none;
  cursor: pointer;
  -webkit-transition: all 0.2s ease;
  -ms-transition: all 0.2s ease;
  transition: all 0.2s ease;
}

.chat-footer .message-bar .message-area {
  display: table-cell;
}

.chat-footer .message-bar .message-area .input-group {
  position: relative;
  flex-wrap: wrap;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: stretch;
  -webkit-box-align: stretch;
  -ms-flex-align: stretch;
}

.chat-footer .message-bar .message-area .input-group .form-control {
  background-color: #FFF;
  border: 1px solid #E9E9EA;
  box-shadow: none;
  color: #4D5154;
  display: block;
  font-size: 14px;
  height: 44px;
  margin: 0;
  padding: 6px 12px;
  resize: none;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  min-height: calc(1.5em + .75rem + calc(1px* 2));
  line-height: 2;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-clip: padding-box;
  transition: border-color .15s ease-in-out, box-shadow .15s ease-in-out;
  border-radius: 0.375rem;
}

.chat-footer .message-bar .message-area .btn {
  height: 44px;
  width: 50px;
  background: linear-gradient(to right, #FF902F 0%, #FC6075 100%);
  color: #FFF;
  position: relative;
  z-index: 2;
  cursor: pointer;
  margin-left: calc(1px* -1);
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  display: inline-block;
  padding: 0.375rem 0.75rem;
  line-height: 1.5;
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  -webkit-user-select: none;
  -moz-user-select: none;
  user-select: none;
  border: 1px solid transparent;
  border-radius: 0.375rem;
  -webkit-appearance: button;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.chat-footer .message-bar .message-area .btn img {
  width: 24px;
  display: inline-block;
  font-style: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
}

.chat-contents .chat-content-wrap .chats .chat-bubble .chat-img-attach {
  position: relative;
  float: right;
  border-radius: 4px;
  margin: 0 0 5px 0px;
  min-height: 10rem;
}

.chat-contents .chat-content-wrap .chats .chat-left .chat-img-attach {
  float: left;
  margin: 0 0 5px 0;
}

.chat-contents .expandable-image img {
  height: 10rem;
  width: auto;
  min-height: 10rem;
}

.mb-120 {
  margin-bottom: 120px;
}

.badgeNumber {
  position: absolute;
  z-index: 2;
  width: auto;
  height: auto;
  top: -4px;
  right: 0px;
  border-radius: 4px;
  padding-left: 3px;
  padding-right: 3px;
  font-size: .625em;
  color: #fff;
  pointer-events: none;
  background-color: #FC133D;
}

.badgeNumber.views {
  font-size: 0.7em;
  top: -8px;
  right: -2px;
  padding: 3px;
  line-height: 1;
  padding-left: 4px;
  padding-right: 4px;
}

.variantes {
  text-align: center;
  border-top: 2px solid black;
}

.variantes-table .svg-inline--fa.fa-w-14 {
  width: 0.6em;
}

.variantes-table .item-row .item-row-actions .btn {
  min-width: 26px;
  padding: 0px;
}

.variantes-table .item-row .item-row-actions {
  width: 30px;
}

.img-table {
  width: 28px;
}

.tempsvar {
  background: linear-gradient(90deg, rgb(210 3 3 / 91%), rgb(223 0 39 / 0%));
}

.istab-rejected {
  background: linear-gradient(90deg, rgba(210, 3, 3, 0.37), rgba(223, 0, 39, 0));
}

.istab-valide {
  background: linear-gradient(90deg, rgba(57, 173, 6, 0.47), rgba(33, 163, 4, 0));
}

.show-img-imp img {
  display: inherit !important;
}

.cc-1lcq {
  font-size: 11px;
  font-weight: 400;
  -webkit-font-smoothing: subpixel-antialiased;
  -moz-osx-font-smoothing: auto;
  padding: 0;
  -webkit-user-select: none;
  user-select: none;
}

.cc-r03y {
  text-align: center;
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 12.4px;
  line-height: 18px;
  letter-spacing: .2px;
  white-space: nowrap;
  color: black;
  padding-top: 30px;
  font-weight: 600;
}

.vue-tags-input {
  max-width: 100% !important;
}

.vue-tags-input .ti-input {
  border: none !important;
}

.vue-tags-input .ti-tag {
  background: #090c1f !important;
  font-size: 0.99em !important;
}
.mb-80 {
    margin-bottom: 80px;
}
/* POD */

.pod-section .product-form__swatch .product-form__radio:checked + .product-form__label{
  border-color: #16bf29;
  border-width: 4px;
}
.pod-section .product-form__radio:checked + .product-form__label .text {
  border-color: #16bf29;
  border-width: 4px;
}
.product-details .product-option {
  display: inherit;
  margin: 0;
}
.product-option {
  font-size: 12px;
  line-height: 1.5;
}
.product-form__input {
  font-size: 0;
  letter-spacing: 0;
  border: none;
  padding: 0;
  margin: 0;
}
.form__label {
  margin-bottom: 8px;
}
.form__label, .form__label-combined {
  display: block;
  margin: 0;
  font-size: 12px;
  font-weight: 500;
  text-transform: capitalize;
  text-align: left;
  color: #222;
  text-transform: uppercase;
}
.form__label [data-header-option] {
  color: #373737;
  font-weight: 400;
  margin-left: 2px;
}
.product-details input[type="radio"] {
  display: none;
  border: 0;
  clip: rect(1px,1px,1px,1px);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  box-sizing: border-box;
  appearance: none;
  background: transparent;
  border-radius: 0;
  min-height: unset;
  outline-offset: unset;
}
.product-form__swatch .product-form__radio:checked + .product-form__label {
  border-color: #242424;
}
.product-form__swatch .product-form__label {
  border-radius: 30px;
  position: relative;
  font-size: 0;
  width: 60px;
  height: 60px;
  border: 1px solid #d0cdcd;
  background: 0 0;
  cursor: pointer;
  padding: 3px;
  opacity: 1;
}
.product-form__label:first-of-type {
  margin-left: 0;
}
.product-form__label {
  display: inline-block;
  vertical-align: top;
  cursor: pointer;
  margin: 5px 10px 10px 0;
}
.product-details label {
  font-weight: 500;
  letter-spacing: .02em;
  line-height: 22px;
  text-transform: capitalize;
  text-align: left;
  color: #222121;
}
.product-form__label .pattern {
  display: block;
  width: 100%;
  height: 100%;
  cursor: pointer;
  border-radius:20px;
  text-align: center;
  font-size: 0;
  letter-spacing: 0;
  position: relative;
  background-size: cover;
  background-position: center;
}
.product-form__input + .product-form__input {
  margin-top: 11px;
}
.product-details input[type="checkbox"],.product-details input[type="radio"] {
  display: none;
  border: 0;
  clip: rect(1px,1px,1px,1px);
  height: 1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px;
  box-sizing: border-box;
}
.product-form__label:first-of-type {
  margin-left: 0;
}

.product-form__radio:checked + .product-form__label .text {
  color: #202020;
  background-color: #fdfcfc;
  border-color: #222121;
}
.product-form__label .text {
  display: flex;
  justify-content: center;
  align-items: center;
  width: auto;
  min-width: 40px;
  height: 40px;
  line-height: 40px;
  border-radius: 0px;
  padding: 0 10px;
  font-size: 12px;
  font-weight: 400;
  text-transform: capitalize;
  border: 1px solid #cccaca;
  text-align: center;
  transition: all ease .3s;
}
.product-form__label .text.price{
  border-top: none;
}

.pod-section{
    padding-top: 13px;
    padding-bottom: 7px;
    padding-right: 14px;
    padding-left: 14px;
    justify-content: center;
    background-size: cover;
    border-radius: 16px;
    border-style: dashed;
    border-color: rgba(155, 97, 3, 0.95);
    border-width: 2px;
    background-color: rgba(199,163,113,0.12);
    position: relative;
    margin-top: 10px;
}
.w-100 {
  width: 100px !important;
}
</style>
